import { forwardRef } from 'react';

import { TooltipProps as MuiTooltipProps, Tooltip } from '@material-ui/core';
import { ToggleButton, ToggleButtonProps } from '@material-ui/lab';

type TooltipToggleButtonProps = ToggleButtonProps & {
  TooltipProps: Omit<MuiTooltipProps, 'children'>;
};

export const TooltipToggleButton = forwardRef<
  HTMLButtonElement,
  TooltipToggleButtonProps
>(({ TooltipProps, ...props }, ref) =>
  props.disabled ? (
    <ToggleButton ref={ref} {...props} />
  ) : (
    <Tooltip {...TooltipProps}>
      <ToggleButton ref={ref} {...props} />
    </Tooltip>
  ),
);
TooltipToggleButton.displayName = 'TooltipToggleButton';
